<template>
   <div>
      <div>
         <img src="../../assets/gif/top.png" alt="">
      </div>
      <div class="imgs">
         <img ref="img" src="../../assets/gif/6_1.gif">
      </div>
   </div>
</template>

<script>
   export default {

   }
</script>
 
<style scoped>
   .imgs{
      height: 20vh;
    width: 20vh;
    margin: 0 auto;
   }
   .guidetext{
      padding: 0;
    margin: 0;
    text-align: center;
    font-size: 3vh;
    font-weight: bold;
    color: #3f88e6;
    margin-bottom: 7vh
   }
</style>